import { buildSrc } from '@amp/web-app-components/src/components/Artwork/utils/srcset';
import type { Me } from '@amp/musickit';
import type { Playback } from '~/utils/playback/browser-only';
import { SubscriberType } from '~/utils/subscription';
import type { User } from './types';

export function makeUser(musicKitUser: Me): User {
    const avatarArt = musicKitUser?.attributes?.avatarArtwork;
    return {
        avatarArtworkUrl: avatarArt
            ? buildSrc(
                  avatarArt?.url,
                  {
                      width: avatarArt.width,
                      height: avatarArt.height,
                      crop: 'cc',
                      fileType: 'webp',
                  },
                  {},
              )
            : null,
        subscriptionStorefront: musicKitUser?.subscription.storefront,
        subscriberType: extractSubscriberType(musicKitUser?.meta),
    };
}

export async function getUserInfo(
    playback: Playback,
    fromCommerceEvent = false,
): Promise<User | null> {
    if (fromCommerceEvent || (await playback.isAuthorized())) {
        let musicKitUser;

        try {
            musicKitUser = await playback.me();
        } catch (_) {
            // no-op
        }

        if (musicKitUser) {
            return makeUser(musicKitUser);
        }
    }

    return null;
}

function extractSubscriberType(meta: any = {}) {
    const { challenge = {} } = meta;
    const { subscriptionCapabilities = [] } = challenge;

    if (subscriptionCapabilities.includes('premium')) {
        // Top Priority Check for Premium so this is first check
        return SubscriberType.Premium;
    } else if (subscriptionCapabilities.includes('voice')) {
        // If Not Premium Subscriber Check for Voice in Capabilities Array
        return SubscriberType.Voice;
    } else {
        // If None of the Valid Subscriber Types found, it means subscription is not Active
        return SubscriberType.NotActive;
    }
}
